import { Injectable, Inject } from '@angular/core'
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable, Subject, takeUntil } from 'rxjs';
import { SAVER, Saver } from './saver.provider'

@Injectable({ providedIn: 'root' })
export class DownloadService {
  private cancelDownload$ = new Subject<void>();

  constructor(
    private http: HttpClient,
    @Inject(SAVER) private save: Saver
  ) {
  }

  download(url: string, filename?: string): Observable<HttpEvent<any>> {
    return this.http.get(url, {
      reportProgress: true,
      observe: 'events',
      responseType: 'blob'
    }).pipe(
      takeUntil(this.cancelDownload$) // Cancel the request when triggered
    );
  }

  saveBlob(blob: Blob, filename?: string): void {
    this.save(blob, filename);
  }

  cancelDownload(): void {
    this.cancelDownload$.next(); // Trigger cancellation
    this.cancelDownload$.complete(); // Complete the subject
  }

  blob(url: string, filename?: string): Observable<Blob> {
    return this.http.get(url, {
      responseType: 'blob'
    })
  }
}
